// extracted by mini-css-extract-plugin
export var sliderRange = "_lv-2";
export var sliderRoot = "_lv-0";
export var sliderThumb = "_lv-3";
export var sliderTrack = "_lv-1";